import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Brain, Cpu, LineChart, Zap, Database, Target } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Link } from 'react-router-dom';

const AIMLPage = () => {
  const solutions = [
    {
      icon: Brain,
      title: 'Machine Learning Models',
      description: 'Build, train, and deploy ML models with Amazon SageMaker',
    },
    {
      icon: Cpu,
      title: 'Deep Learning',
      description: 'Accelerated deep learning with GPU instances and frameworks',
    },
    {
      icon: LineChart,
      title: 'Predictive Analytics',
      description: 'Advanced analytics and forecasting for business intelligence',
    },
    {
      icon: Database,
      title: 'Data Processing',
      description: 'Large-scale data processing for ML workloads with AWS EMR',
    },
    {
      icon: Zap,
      title: 'Real-time Inference',
      description: 'Low-latency AI inference for real-time applications',
    },
    {
      icon: Target,
      title: 'Computer Vision',
      description: 'Image and video analysis with AWS Rekognition and custom models',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#020B1A] to-[#061426]">
      <Navbar />
      
      <section className="relative bg-gradient-to-br from-[#020B1A] via-[#061426] to-[#0A1E3F] overflow-hidden text-white pt-32 pb-24 mt-16">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-20 w-96 h-96 bg-cyan-500/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-600/30 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              AI & Machine Learning Solutions
            </h1>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              Accelerate innovation with AI and machine learning solutions powered by AWS. Build intelligent applications with cutting-edge ML services.
            </p>
            <Link to="/contact">
              <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-medium px-8 py-6 text-lg transition-all duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.5)' }}>
                Explore AI Solutions
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-[#061426] to-[#020B1A]">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">AI & ML Infrastructure</h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Comprehensive AI and machine learning services for every use case
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((solution, index) => {
              const Icon = solution.icon;
              return (
                <div 
                  key={index} 
                  className="bg-gradient-to-br from-[#061426] to-[#0A1E3F] border border-cyan-500/30 rounded-xl p-8 transition-all duration-300 hover:border-cyan-400 hover:shadow-2xl"
                  style={{ boxShadow: '0 4px 20px rgba(0, 212, 255, 0.1)' }}
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 rounded-lg flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-cyan-400" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{solution.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{solution.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-[#020B1A] via-[#061426] to-[#0A1E3F] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-20 w-64 h-64 bg-cyan-500/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-20 w-64 h-64 bg-blue-600/30 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Transform Your Business with AI
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
            Deploy world-class AI and machine learning solutions on AWS
          </p>
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-medium px-10 py-6 text-lg transition-all duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.5)' }}>
              Get AI Consultation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AIMLPage;
